import * as React from 'react';

export const RememberCheckSvg: React.FC = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={10}
    height={9}
    fill='none'
  >
    <path
      stroke='#748BA0'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.071}
      d='M8.81 1.643 3.57 6.88 1.191 4.5'
    />
  </svg>
);
